module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescirp9-f2c42c65071441a0db69b3cb49452bf3.jpg";